export default "__VITE_ASSET__254d8fdf__"